import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import * as _ from 'lodash';
import { IBillingState, BillingActionCreators, IApplicationState, AppActionCreators, IBilledToListResponse, IAppState } from '@nkr/store/index';
import { IBilledCenterForList, ISortBy } from '@nkr/models/index';
import { Glyphicon, Button } from 'react-bootstrap';
import BilledToCenterRow from './billed-to-center-row';
import { statusMap } from '../status-map';
import { TableWrapper } from '../styles';
import NoData from '../no-data';
import NavRecipientCenter from '../nav-recipient-center';
import { NavSubWrapper } from '../../styles';
import BilledByToFilter from '../billed-by-to-filter';

interface IOwnProps {
    centerId: number,
    centerAlias: string
}

interface IStateProps {
    app: IAppState,
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBilledToList: (centerId: number) => Promise<IBilledToListResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    sortBy: ISortBy,
    dateRange: number,
    status: number
}

class BilledByCenter extends React.Component<TProps, IState> {
    readonly state: IState = {
        sortBy: { property: 'transplantDate', direction: "asc" },
        dateRange: 0,
        status: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);

        if (sortBy.property == property) {
            if (sortBy.direction == 'asc') {
                sortBy.direction = 'desc'
            } else {
                if (sortBy.direction == 'desc') {
                    sortBy = { property: '', direction: '' };
                }
            }
        } else {
            sortBy = { property, direction: 'asc' };
        }

        this.setState({
            sortBy
        });
    }

    handleViewCharges = (donorId: number) => {
        window.location.href = `/center/${this.props.centerId}/billing/view-charges/${donorId}`;
    }

    handleDateRangeChange = (dateRange: number) => {
        this.setState({
            dateRange
        });
    }

    handleStatusChange = (status: number) => {
        this.setState({
            status
        });
    }

    getData = () => {
        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.getBilledToList(this.props.centerId).then(response => {
                this.props.hideLoading();
            });
        });
    }

    getFilteredRows = () => {
        return this.props.billing.billedToCenter.filter(x => {
            let dateRange = this.state.dateRange > 0 ? moment(x.transplantDate).isAfter(moment().addDays(-1 * this.state.dateRange)) : true;
            let status = this.state.status > 0 ? x.statusId == this.state.status : true;

            return dateRange && status;
        });
    }

    getSortedRows = () => {
        let { property, direction } = this.state.sortBy;
        let filteredRows = this.getFilteredRows();
        let sortedRows: IBilledCenterForList[] = [];

        if (property != '') {
            sortedRows = _.orderBy(filteredRows, item => {
                switch (property) {
                    case 'transplantDate': return moment(item.transplantDate).format('YYMMDD');
                    case 'swapNumber': return parseInt(item.chainId + '' + item.clusterNumber + '' + item.positionNumber);
                    case 'donorCenter': return item.donorCenterAlias;
                    case 'donorAlias': return item.donorAlias;
                    case 'recipientAlias': return item.recipientAlias;
                    case 'recipientCenter': return item.recipientCenterAlias;
                    case 'claimType': return item.claimType;
                    case 'invoiceDate': return moment(item.invoiceDate).format('YYMMDD');
                }

            }, [direction]);
        } else {
            sortedRows = filteredRows;
        }

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const rows = this.getSortedRows();

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <NavSubWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                        <NavRecipientCenter
                            section={'BILLED-TO-CENTER'}
                            tabText={''}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />

                        <BilledByToFilter
                            dateRange={this.state.dateRange}
                            status={this.state.status}
                            isAdminLogin={this.props.app.user.group.isSuper}
                            onDateRangeChange={this.handleDateRangeChange}
                            onStatusChange={this.handleStatusChange}
                        />
                    </NavSubWrapper>

                    {rows.length > 0 ?
                        <>
                            <TableWrapper bordered condensed striped>
                                <thead>
                                    <tr>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('transplantDate')}>TXP Date  {this.renderHeaderSort('transplantDate')}</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('swapNumber')}>Swap #  {this.renderHeaderSort('swapNumber')}</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('donorCenter')}>Donor Center {this.renderHeaderSort('donorCenter')}</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('donorAlias')}>Donor Alias {this.renderHeaderSort('donorAlias')}</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('recipientCenter')}>Recipient Center {this.renderHeaderSort('recipientCenter')}</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('recipientAlias')}>Recipient Alias {this.renderHeaderSort('recipientAlias')}</th>
                                        <th style={{ cursor: 'default', minWidth: '130px' }} onClick={() => this.handleSort('claimType')}>Claim Type  {this.renderHeaderSort('claimType')}</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Disputed By</th>
                                        <th>Billed By</th>
                                        <th style={{ cursor: 'default' }} onClick={() => this.handleSort('invoiceDate')}>Invoice<br />Date {this.renderHeaderSort('invoiceDate')}</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((item, index) =>
                                        <BilledToCenterRow
                                            key={index}
                                            data={item}
                                            onViewCharges={this.handleViewCharges}
                                        />
                                    )}
                                </tbody>
                            </TableWrapper>
                            <div style={{ textAlign: 'right' }}>{rows.length} items...</div>
                        </>
                        :
                        <NoData message={'No ' + (this.state.status > 0 ? statusMap[this.state.status] : '') + ' charges...'} />
                    }

                    <div style={{ textAlign: 'center' }}>
                        <Button bsStyle="primary" style={{ textAlign: 'center' }}
                            href={`center/${this.props.centerId}/profile/edit`}>
                            Enter / Update <br />Banking Information
                        </Button>
                    </div>
                </div>
                <br />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app,
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBilledToList: (centerId) => {
            return dispatch(BillingActionCreators.getBilledToList(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(BilledByCenter);